module.exports = __webpack_public_path__ + "img/r-211.93167c6c.jpg";